<template>
  <!-- 入库管理 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :table-loading="loading"
      :option="tableOption"
      :data="listData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="loadData"
      @on-load="loadData"
    >
      <template slot="menuLeft">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openFromDialog('add')">
          入库
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          icon="el-icon-printer"
          plain
          @click="doPrint(scope.row)"
        >
          打印
        </el-button>
      </template>
      <template slot="warehouseIdSearch">
        <el-select style="width: 100%" v-model="searchForm.warehouseId">
          <el-option
            v-for="(item, index) in warehouseList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>
      <template slot="typeSearch">
        <el-select style="width: 100%" v-model="searchForm.type">
          <el-option
            v-for="(item, index) in typeSearchList"
            :key="index"
            :label="item.dictValue"
            :value="item.dictKey"
          ></el-option>
        </el-select>
      </template>
      <template slot="inboundNo" slot-scope="scope">
        <el-link type="primary" :underline="false" @click="openFromDialog('view', scope.row)">
          {{ scope.row.inboundNo }}
        </el-link>
      </template>
      <template slot="inboundAmount" slot-scope="scope">
        {{ tool.money_format_allowvoid(scope.row.inboundAmount) }}
      </template>
      <template slot="submitRqSearch">
        <el-date-picker
          style="width: 100%"
          v-model="searchForm.submitRq"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          type="date"
          placeholder="操作日期"
          size="small"
        >
        </el-date-picker>
      </template>
    </avue-crud>
    <!-- 新增入库的表单弹框 -->
    <el-dialog
      title="入库"
      width="80%"
      :visible.sync="isFormDialogShow"
      :before-close="beforeCloseFormDialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <!-- 查看详情 -->
      <WarehouseInDetail
        v-if="isFormDialogShow && formType == 'view'"
        :projectId="rowData.projectId"
        :orderId="rowData.id"
        :orderType="rowData.type"
      ></WarehouseInDetail>
      <!-- 新增 -->
      <WarehouseInForm
        v-else-if="isFormDialogShow && formType == 'add'"
        :projectId="searchForm.projectId"
        @update="addSuccess"
        @close="beforeCloseFormDialog"
      ></WarehouseInForm>
    </el-dialog>
  </basic-container>
</template>

<script>
import WarehouseInDetail from './warehouse-in-detail';
import WarehouseInForm from './warehouse-in-form';
import { getProjectListApi, getWarehouseListApi } from '@/api/warehouse/index';
import { getPageListApi } from '@/api/warehouse/in';

export default {
  name: 'WarehouseInIndex',
  components: {
    WarehouseInDetail,
    WarehouseInForm,
  },
  data() {
    return {
      // 旧项目id，重置搜索条件时需要使用
      oldProjectId: '',
      // 旧仓库id，重置搜索条件时需要使用
      oldWarehouseId: '',
      // 项目列表
      projectList: [],
      // 仓库列表
      warehouseList: [],
      // 搜索表单
      searchForm: {},
      // 当前行数据
      rowData: null,
      // 当前表单类型 view-查看 add-新增 edit-编辑
      formType: 'add',
      // 表单弹框是否显示着
      isFormDialogShow: false,
      // 关闭表单弹框时是否需要确认框
      needCloseConfirm: true,
      // 列表数据
      listData: [],
      // 是否正在加载数据
      loading: false,
      // 是否为第一次获取数据
      isFirstLoadData: true,
      // 表格分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格选项
      tableOption: {
        height: 'auto',
        calcHeight: 90,
        border: true,
        index: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        dialogClickModal: false,
        searchMenuSpan: 12,
        searchLabelWidth: 100,
        labelWidth: 100,
        menuWidth: 80,
        column: [
          {
            label: '项目名称',
            prop: 'projectId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
            hide: true,
            showColumn: false,
            type: 'select',
            search: true,
            searchClearable: false,
          },
          {
            label: '仓库名称',
            prop: 'warehouseId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
            type: 'select',
            search: true,
            searchslot: true,
            searchClearable: false,
          },
          {
            label: '入库类型',
            prop: 'type',
            dicUrl: '/api/blade-system/dict/dictionary?code=warehouse_inbound_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            search: true,
            type: 'select',
          },
          {
            label: '操作日期',
            prop: 'submitRq',
            search: true,
            searchslot: true,
            hide: true,
            showColumn: false,
          },
          {
            label: '入库单号',
            prop: 'inboundNo',
            width: 200,
            slot: true,
            search: true,
            maxlength: 30,
            showWordLimit: true,
          },
          {
            label: '关联单号',
            prop: 'linkNo',
            width: 200,
            search: true,
            maxlength: 30,
            showWordLimit: true,
          },
          {
            label: '物料摘要',
            prop: 'materialSummary',
          },
          {
            label: '入库数量',
            prop: 'quantityNum',
          },
          {
            label: '入库金额',
            prop: 'inboundAmount',
            align: 'right',
            slot: true,
          },
          {
            label: '操作人',
            prop: 'submitUserName',
          },
          {
            label: '操作时间',
            prop: 'submitTime',
          },
        ],
      },
    };
  },
  created() {
    getProjectListApi().then(({ data }) => {
      this.projectList = data || [];
      if (this.projectList.length > 0) {
        this.findObject(this.tableOption.column, 'projectId').dicData = this.projectList;
        if (!this.searchForm.projectId) {
          this.searchForm.projectId = this.projectList[0].id;
        }
      }
    });
  },
  mounted() {
    this.ajustViewHeight();
  },
  watch: {
    'searchForm.projectId'(val) {
      if (val) {
        this.oldProjectId = this.searchForm.projectId;
        // 更新仓库列表
        getWarehouseListApi({
          projectId: this.searchForm.projectId,
        }).then(({ data }) => {
          this.warehouseList = data;
          // 当前的分页接口必须要有仓库id才能拿到数据，所以这里强制设为第一个
          if (this.warehouseList.length > 0) {
            let firstWarehouse = this.warehouseList.find((ele) => {
              return ele.status == 1;
            });
            this.searchForm.warehouseId = firstWarehouse ? firstWarehouse.id : '';
            if (this.isFirstLoadData) {
              this.isFirstLoadData = false;
              // 仓库的字典更新一定要注意时机，否则仓库会显示成id，并非name
              this.findObject(this.tableOption.column, 'warehouseId').dicData = this.warehouseList;
              this.loadData();
            }
          } else {
            this.isFirstLoadData = false;
            this.searchForm.warehouseId = '';
            this.oldWarehouseId = '';
          }
        });
      }
    },
    'searchForm.warehouseId'(val) {
      if (val) {
        this.oldWarehouseId = this.searchForm.warehouseId;
      }
    },
  },
  methods: {
    /* 调整视图区域高度 */
    ajustViewHeight() {
      const tableInitH = this.bodyHeight - 400; // 表格区域初始化高度
      const searchH = 112; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });
    },
    /* 加载列表数据 */
    loadData(page) {
      if (this.isFirstLoadData) return;
      page = page || this.tablePage;
      this.loading = true;
      getPageListApi(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm)
      )
        .then(({ data }) => {
          this.tablePage.total = data.total;
          this.listData = data.records;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    /* 重置搜索 */
    searchReset() {
      this.searchForm = {
        projectId: this.oldProjectId,
        warehouseId: this.oldWarehouseId,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.findObject(this.tableOption.column, 'warehouseId').dicData = this.warehouseList; // 在搜索时才更新仓库的字典，否则如果只是单纯的切换项目这个搜索条件，又提前更新了仓库字典，那表格里的仓库就会显示仓库id了
      this.searchForm = params;
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },

    /* 打开表单弹框 */
    openFromDialog(type, rowData) {
      this.formType = type;
      this.rowData = rowData;
      if (this.formType == 'view') {
        this.needCloseConfirm = false;
      } else {
        this.needCloseConfirm = true;
      }
      this.isFormDialogShow = true;
    },
    /* 关闭表单弹框的确认框 */
    beforeCloseFormDialog(done) {
      if (!this.needCloseConfirm) {
        if (typeof done == 'function') {
          done();
        } else {
          this.isFormDialogShow = false;
        }
      } else {
        this.$confirm(' 是否关闭继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (typeof done == 'function') {
              done();
            } else {
              this.isFormDialogShow = false;
            }
          })
          .catch(() => {});
      }
    },
    addSuccess() {
      this.loadData();
      this.isFormDialogShow = false;
    },
    /* 打印 */
    doPrint(rowData) {
      this.rowData = rowData;
      // todo 打印功能欠缺
      this.$message.warning('待开放');
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
